import PropTypes from 'prop-types';

import { StatusBadge } from '#/modules/commonComponents/badge';
import {
  formatRepairRequestStatusLabel,
} from '#/modules/crmMgmt/aftersales/repairRequest/helper/repairRequestStatus';

const RepairRequestStatusBadge = ({ status, size = 'default', className }) => (
  <StatusBadge
    status={status}
    label={formatRepairRequestStatusLabel(status)}
    size={size}
    className={className}
  />
);

RepairRequestStatusBadge.propTypes = {
  status: PropTypes.string,
  size: PropTypes.oneOf(['default', 'sm']),
  className: PropTypes.string,
};

export default RepairRequestStatusBadge;
